var productShowThumbs = new Swiper(".tb-product-show .tb-product-show-thumbs", {
  spaceBetween: 8,
  slidesPerView: isMobile() ? 5 : 'auto',
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  observer: true,
  observeParents: true,
});
var productShow = new Swiper(".tb-product-show .tb-product-show-slide", {
  loop: true,
  spaceBetween: 10,
  observer: true,
  observeParents: true,
  navigation: {
    nextEl: ".tb-product-show .swiper-button-next",
    prevEl: ".tb-product-show .swiper-button-prev",
  },
  thumbs: {
    swiper: productShowThumbs,
  },
});

var sceneSwiper = new Swiper(".tb-product-scene-swiper", {
  slidesPerView: isMobile() ? 1.3 : 3,
  spaceBetween: isMobile() ? 12 : 24,
  on: {
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.update();
        this.enable();
        this.params.spaceBetween = 12;
        this.params.slidesPerView = 1.3;
      } else {
        this.disable();
        this.params.spaceBetween = 24;
        this.params.slidesPerView = 3;
      }
    },
  },
});

var sceneSwiper = new Swiper(".tb-product-selling-swiper", {
  slidesPerView: isMobile() ? 1 : 3,
  spaceBetween: 24,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  on: {
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.update();
        this.enable();
        this.params.spaceBetween = 12;
        this.params.slidesPerView = 1;
      } else {
        this.disable();
        this.params.spaceBetween = 24;
        this.params.slidesPerView = 3;
      }
    },
  }
});



if (!isMobile()) {
  $(".tb-product-show-image").imagezoomsl({
    zoomrange: [3, 3]
  });
}


if (IsAppleStore()) {
  // $('.tb-product-video-play').hide()
}

// 复制折扣码
let codeCopy = document.querySelectorAll('.tb-product-coupon-copy');
let clipboard = new Clipboard(codeCopy);
clipboard.on('success', function (e) {
  let successCon = "<div class='tb-toast'>Successfully copied!  </div>"
  $('.tb-product-coupon-wrap').append(successCon);
  setTimeout(function () {
    $('.tb-toast').remove();
  }, 1000)
});


var bodyworkSlide = new Swiper(".tb-product-grid-slide", {
  pagination: {
    el: ".tb-product-grid-slide .swiper-pagination",
  },
  on: {
    init: function (swiper) {
      if (!isMobile() || $(window).width() > 768) {
        this.disable();
        return;
      }
      this.params.spaceBetween = 10;
    },
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.update();
        this.enable();
        this.params.spaceBetween = 10;
      } else {
        this.disable();
      }
    },
  },
});

var sceneSlide = new Swiper(".tb-product-slideshow .tb-product-slideshow-swiper", {
  slidesPerView: 'auto',
  spaceBetween: 24,
  scrollbar: {
    el: ".tb-product-slideshow-swiper .swiper-scrollbar",
  },
  navigation: {
    nextEl: ".tb-product-slideshow .swiper-button-next",
    prevEl: ".tb-product-slideshow .swiper-button-prev",
  },
  on: {
    init: function () {
      if (isMobile() || $(window).width() <= 768) {
        this.params.spaceBetween = 12;
      }
    },
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.params.spaceBetween = 12;
      }
    }
  }
});

var sceneSlide2 = new Swiper(".tb-product-slideshow .tb-product-slideshow-swiper2", {
  slidesPerView: isMobile() ? 'auto' : 4,
  spaceBetween: 24,
  scrollbar: {
    el: ".tb-product-slideshow-swiper2 .swiper-scrollbar",
  },
  navigation: {
    nextEl: ".tb-product-slideshow .swiper-button-next",
    prevEl: ".tb-product-slideshow .swiper-button-prev",
  },
  on: {
    init: function () {
      if (isMobile() || $(window).width() <= 768) {
        this.params.spaceBetween = 12;
      }
    },
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.params.spaceBetween = 12;
      }
    }
  }
});

// var safeSlide = new Swiper(".safe-slideshow .tb-product-safeshow-swiper", {
//   slidesPerView: 'auto',
//   spaceBetween: 24,
//   scrollbar: {
//     el: ".safe-slideshow .swiper-scrollbar",
//   },
//   on: {
//     init: function () {
//       if (isMobile() || $(window).width() <= 768) {
//         this.enable();
//         this.params.spaceBetween = 12;
//       } else {
//         this.disable();
//       }
//     },
//     resize: function (swiper) {
//       if (isMobile() || $(window).width() <= 768) {
//         this.enable();
//         this.params.spaceBetween = 12;
//       } else {
//         this.disable();
//       }
//     }
//   }
// });

var swiper = new Swiper(".slideShowSwiper", {
  autoplay: true,
  pagination: {
    el: ".slideShowSwiper .swiper-pagination",
  },
  navigation: {
    nextEl: '.tb-product-slide-show-box .swiper-button-next',
    prevEl: '.tb-product-slide-show-box .swiper-button-prev',
  },
});

var swiper = new Swiper(".slideShowSwiper2", {
  autoplay: true,
  slidesPerView: isMobile() ? 1.5 : 5,
  spaceBetween: isMobile() ? 8 : 16,
});

var socialSlide = new Swiper(".tb-product-social-media-swiper", {
  spaceBetween: 10,
  pagination: {
    el: ".swiper-pagination",
  },
  on: {
    init: function (swiper) {
      if (!isMobile() || $(window).width() > 768) {
        this.disable();
      }
    },
    resize: function (swiper) {
      if (isMobile() || $(window).width() <= 768) {
        this.update();
        this.enable();
      } else {
        this.disable();
      }
    },
  }
});

// 服务选项卡首次加载
$('.tb-product-serve-tab span').eq(0).addClass('active')
$('.tb-product-serve-tab-content .tb-product-serve-tab-item').eq(0).addClass('active')
let couponLen = $('.tb-product-coupon .tb-product-coupon-item').length;
couponLen == 0 && $('.tb-product-coupon-btn').remove();
// 选项切换
$('.tb-product-variant-select-val').click(function (e) {
  $(this).parent().toggleClass('active');
  $(this).parent().next().slideToggle();
});

$('.tb-product-variant-select-list li').click(function () {
  $(this).addClass('selected').siblings().removeClass('selected');
  let text = $(this).text();
  let id = getVariantIdByOption();
  let selectedVariantOption = $('.tb-product-variant-hidden').find(`option[value='${id}'`);
  let variantavailable = selectedVariantOption.data('available');
  let variantTitle = selectedVariantOption.data('title');
  let isCaPreOrder = $("#isCaPreOrder").val();
  $(this).parent().prev().find('.tb-product-variant-select-val').val(text)
  // $(this).parent().slideUp();
  $(this).parent().prev().removeClass('active');
  $('#variantId').val(id)
  $('.tb-product-variant-hidden').find('option').attr('selected', false);
  $('.tb-product-variant-hidden').find(`option[value='${id}']`).attr('selected', true)
  $('#finalPrice').html($('.tb-product-variant-hidden').find(`option[value='${id}'`).data('price'));
  $('#underlinedPrice').html($('.tb-product-variant-hidden').find(`option[value='${id}'`).data('compare-at-price'));
  if (variantavailable) {
    if (variantTitle.includes("Canada") && isCaPreOrder == 'true') {
      $('#addCart').text( $('#addCart').data('pre-order'));
    } else {
      $('#addCart').text( $('#addCart').data('add-cart'));
    }
    $('#addCart').removeClass('tb-product-handle-add-disabled').attr('disabled', false);
    $('.tb-product-handle-checkout').removeClass('hide');
  } else {
    $('#addCart').text( $('#addCart').data('sold-out'));
    $('#addCart').addClass('tb-product-handle-add-disabled').attr('disabled', true);
    $('.tb-product-handle-checkout').addClass('hide');
  }
  let soldOutMessageContainer = $('.tb-product-handle-soldout-metafield');
  if (soldOutMessageContainer.length > 0) {
    let soldOutMessage = JSON.parse(selectedVariantOption.attr('data-sold-out-message') || '""');
    let soldOutMessageText = soldOutMessageContainer.find('span');
    soldOutMessageText.text(soldOutMessage);
    soldOutMessageText.html(soldOutMessageText.html().replace(/\r?\n/g, '<br>'));
    soldOutMessageContainer.toggleClass('hide', variantavailable || soldOutMessage.trim() === '');
  }
  if ($('.variant-desc').length > 0) {
    $('.variant-desc').addClass('hide');
    $('.' + id).removeClass('hide');
  }
  getRecPur();
})

function getVariantIdByOption() {
  let variantId = '';
  let variantTitle = '';
  $('.tb-product-variant-select-list').each(function (index, item) {
    let optionValue = $(item).find('li.selected').text();
    if (index == 0) {
      variantTitle = optionValue;
    } else {
      variantTitle = variantTitle + ' / ' + optionValue;
    }
  });
  console.log(variantTitle);
  $('.tb-product-variant-hidden').find('option').each(function (index, item) {
    if ($(item).data('title') == variantTitle) {
      variantId = $(item).val();
    }
  })
  return variantId;
}


// 加减数量
$('.tb-product-qty-min').click(function () {
  let qtyValue = parseInt($('.tb-product-qty-val').val());
  qtyValue !== 1 && qtyValue--;
  qtyValue == 1 ? $(this).addClass('disabled') : $(this).removeClass('disabled')
  $('.tb-product-qty-val').val(qtyValue)
})

$('.tb-product-qty-add').click(function () {
  let qtyValue = parseInt($('.tb-product-qty-val').val());
  qtyValue++;
  qtyValue == 1 ? $('.tb-product-qty-min').addClass('disabled') : $('.tb-product-qty-min').removeClass('disabled')
  $('.tb-product-qty-val').val(qtyValue)
})
$('.tb-product-payment-more p').click(function () {
  $(this).next().slideToggle();
})



let productVideo = document.querySelector('#productVideo')
let productVideoWap = document.querySelector('#productVideoWap')
$('.tb-product-video').hover(function () {
  $('#productVideo').attr('controls', true)
}, function () {
  $('#productVideo').attr('controls', false)
});
$('.tb-product-video-play').click(function () {
  $(this).fadeOut();
  productVideo.play();
})
if (productVideo) {
  productVideo.addEventListener('play', function () { //开始
    $('.tb-product-video-play').fadeOut();
    $('.tb-product-video .video-info').fadeOut();
  });
  productVideo.addEventListener('pause', function () { //暂停
    $('.tb-product-video-play').fadeIn();
    $('.tb-product-video .video-info').fadeIn();
  });
  productVideo.addEventListener('ended', function () { //结束
    $('.tb-product-video-play').fadeIn();
    $('.tb-product-video .video-info').fadeIn();
  }, false);
}

$('.tb-product-video-play2').click(function () {
  $(this).fadeOut();
  
  if (isMobile()) {
    productVideoWap.play();
  } else {
    productVideo.play();
  }
  
})
if (productVideoWap) {
  productVideoWap.addEventListener('play', function () { //开始
    $('.tb-product-video-play2,.video-info').fadeOut();
  });
  productVideoWap.addEventListener('pause', function () { //暂停
    $('.tb-product-video-play2,.video-info').fadeIn();
  });
  productVideoWap.addEventListener('ended', function () { //结束
    $('.tb-product-video-play2,.video-info').fadeIn();
  }, false);
}

$('.tb-product-serve-tab span').click(function () {
  $(this).addClass('active').siblings().removeClass('active');
  $('.tb-product-serve-tab-item').eq($(this).index()).addClass('active').siblings().removeClass('active')
})

$('.tb-product-coupon-btn').click(function () {
  $('.tb-product-coupon-item:not(first-child)').toggleClass('active')
})

let paymentList = $('.tb-payment-list').html();
$('.tb-product-payment-details').html(paymentList)
if (!isMobile()) {
  $('.tb-product-handle-checkout').on("mouseover mouseout", '.shopify-payment-button__more-options', function (event) {
    if (event.type == "mouseover") {
      $('.tb-product-payment-details').slideDown();
    } else if (event.type == "mouseout") {
      //鼠标离开
      $('.tb-product-payment-details').slideUp();
    }
  })
}
if (isMobile || $(window).width() <= 768) {
  $('.icon-notes').click(function () {
    $('.tb-product-payment-details').slideToggle();
  });
}


$('.tb-product-spec-box dt').click(function () {
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    $(this).next().slideUp();
    $(this).find('.iconfont').addClass('icon-add').removeClass('icon-reduce')
  } else {
    $(this).addClass('active');
    $(this).next().slideDown();
    $(this).find('.iconfont').removeClass('icon-add').addClass('icon-reduce')
  }
})

$('.tb-product-data-title.down').click(function () {
  if ($(this).next().is(':hidden')) {
    $(this).next().slideDown();
    $(this).find('.iconfont').removeClass('icon-add').addClass('icon-reduce')
  } else {
    $(this).next().slideUp();
    $(this).find('.iconfont').addClass('icon-add').removeClass('icon-reduce')
  }
})

$('.tb-product-faq-item h4').click(function () {
  $(this).toggleClass('active')
  $(this).next().slideToggle();
})

// 点击楼层跳跃
var flag = true //设置标识。防止出现跑马灯
let hdHeight;
if (sessionStorage.getItem('barStatus') || !$('.tb-product-tabs-list').attr('data-barstatus')) {
  hdHeight = 72;
} else if ($('.tb-product-tabs-list').attr('data-barstatus')) {
  hdHeight = 112;
}
if (flag) {
  $(window).scroll(function () {
    var scrollT = $(window).scrollTop()
    var len = $(".tb-product-tab-main").length
    for (let i = 0; i < len; i++) {
      var bannerGap = $(".tb-product-tab-main")[i].offsetTop - $('.tb-product-tabs-list').height() - hdHeight;
      if (scrollT > bannerGap) {
        $(".tb-product-tabs-item").eq(i).addClass("active").siblings().removeClass("active")
        let moveX = $('.tb-product-tabs-item').eq(i).position().left + $('.tb-product-tabs-item').eq(i).parent().scrollLeft()
        let pageX = document.documentElement.clientWidth;
        let blockWidth = $(".tb-product-tabs-item").eq(i).width();
        let left = moveX - (pageX / 2) + (blockWidth / 2);
        if (isMobile()) {
          $(".tb-product-tabs-list").stop(true).animate({
            "scrollLeft": left
          })
        }
      }
    }
  })
}
$(".tb-product-tabs-item").click(function () {
  flag = false;
  isReview = false;
  var index = $(this).index() //获取当前点击元素的索引  
  let moveX = $(this).position().left + $(this).parent().scrollLeft();
  let pageX = document.documentElement.clientWidth;
  let blockWidth = $(this).width();
  let left = moveX - (pageX / 2) + (blockWidth / 2);
  if (index == 2) {
    $('.tb-product-pack-box').slideDown()
  } else if (index == 3) {
    $('.tb-product-faq-box').slideDown()
  } else if (index == 4) {
    $('.tb-product-compare-box').slideDown()
  }
  //判断 $(".tb-product-tab-main").eq(index).offset().top 是否undefined

  if ($(".tb-product-tab-main").eq(index).offset() == undefined) {
    flag = false
    return
  }
  var top = $(".tb-product-tab-main").eq(index).offset().top - $('.tb-product-tabs-list').height() - hdHeight; //获取每个内容到顶部的距离 
  $("html,body").stop(true).animate({
    "scrollTop": top + 5
  }, function () {
    flag = true
  })
  if (isMobile()) {
    $(".tb-product-tabs-list").stop(true).animate({
      "scrollLeft": left
    })
  }
})






// 添加到购物车
let currentProduct = document.getElementById('productPage'); //当前产品ID
let variantId = document.getElementById('variantId'); //当前产品变体
let numInput = document.getElementById('productQty'); //购买页产品加购数量
let loading = document.getElementById('loading'); //加载
$('.tb-product-addBtn').click(function (e) {
  let id = variantId.value || currentProduct.getAttribute('data-id');
  let quantity = numInput.value;
  let formDate = {
    form_type: 'product',
    utf8: '✓',
    id,
    quantity
  }
  loading.classList.add('active');
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    data: formDate,
    dataType: 'json',
    success(res) {
      if (res) {
        getCartData();
        $('.tb-product-warning').fadeOut();
      }
    },
    error(err) {
      let responseText = JSON.parse(err.responseText);
      if (err.status == 422) {
        $('.tb-product-warning').fadeIn();
        loading.classList.remove('active');
        $('.tb-product-warning p').html(responseText.description)
        let successCon = "<div class='tb-toast'>" + responseText.description + "</div>"
        $('body').append(successCon);
        setTimeout(function () {
          $('.tb-toast').remove();
        }, 1000)
      }
    }
  })
})


$('.product-compare-btn').click(function (e) {
  let id = $(this).data('variantid') || $(this).data('id');
  let formDate = {
    form_type: 'product',
    utf8: '✓',
    quantity: 1,
    id,
  }
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    data: formDate,
    dataType: 'json',
    success(res) {
      if (res) {
        getCartData();
      }
    },
    error(err) {
      let responseText = JSON.parse(err.responseText);
      if (err.status == 422) {
        let successCon = "<div class='tb-toast'>" + responseText.description + "</div>"
        $('body').append(successCon);
        setTimeout(function () {
          $('.tb-toast').remove();
        }, 1000)
      }
    }
  });
})


// 倒计时
let time = $('#countdown').data('time')
$(`#countdown`).timeTo({
  timeTo: new Date(time),
  theme: "black",
  displayDays: 2,
  displayCaptions: true,
  fontSize: !isMobile() ? 30 : 24,
  captionSize: !isMobile() ? 14 : 12,
  lang: 'en',
  countdown: true
});



// 打开购物车
function toggleCart(type) {
  loading.classList.remove('active');
  let cartModal = document.querySelector('.tb-shop-cart');
  let shade = document.querySelector('.tb-shade');
  if (type == 'open') {
    cartModal.classList.add('show')
    shade.classList.add('show')
  } else if (type == 'add') {
    cartModal.classList.add('show')
    setTimeout(() => {
      cartModal.classList.remove('show')
      shade.classList.remove('show')
    }, 10000)
  } else {
    cartModal.classList.remove('show')
    shade.classList.remove('show')
  }
}

$('.tb-product-coupon-sale').click(function () {
  $('.tb-product-coupon-hint').fadeIn();
  setTimeout(() => {
    $('.tb-product-coupon-hint').fadeOut();
  }, 3000);
})

$('.tb-product-coupon-hint i').click(function () {
  $('.tb-product-coupon-hint').fadeOut();
})




// buy button
// var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
// if (window.ShopifyBuy) {
//   if (window.ShopifyBuy.UI) {
//     ShopifyBuyInit();
//   } else {
//     loadScript();
//   }
// } else {
//   loadScript();
// }

// function loadScript() {
//   var script = document.createElement('script');
//   script.async = true;
//   script.src = scriptURL;
//   (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
//   script.onload = ShopifyBuyInit;
// }

// function ShopifyBuyInit() {
//   var client = ShopifyBuy.buildClient({
//     domain: 'turboant.com',
//     storefrontAccessToken: 'b0f1bb69a767b8a384e7c94ddd6e7f8a',
//   });
//   let productBtn = document.getElementById('product-component');
//   let productId = productBtn.getAttribute('data-id');
//   ShopifyBuy.UI.onReady(client).then(function (ui) {
//     ui.createComponent('product', {
//       id: productId,
//       node: document.getElementById('product-component'),
//       moneyFormat: '%24%7B%7Bamount%7D%7D',
//       options: {
//         "product": {
//           iframe: false,
//           "buttonDestination": "checkout",
//           "contents": {
//             "img": false,
//             "title": false,
//             "price": false
//           },
//           "classes": {
//             button: "tb-fixed-checkout"
//           },
//           "text": {
//             "button": "BUY IT NOW"
//           }
//         }
//       }
//     });
//   });
// }

// checkout按钮
$('#product-checkout-button').click(function () {
  const variantId = $('#variantId').val() || currentProduct.getAttribute('data-id');
  const quantity = $('#productQty').val() || 1;
  
  const mutation = `
    mutation {
      cartCreate(
        input: {
          lines: [
            {
              quantity: ${quantity}
              merchandiseId: "gid://shopify/ProductVariant/${variantId}"
            }
          ]
        }
      ) {
        cart {
          id
          checkoutUrl
        }
      }
    }
  `;

  fetch('/api/2025-01/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': 'b0f1bb69a767b8a384e7c94ddd6e7f8a'
    },
    body: JSON.stringify({ query: mutation })
  })
  .then(response => response.json())
  .then(result => {
    if (result.data && result.data.cartCreate && result.data.cartCreate.cart) {
      window.location.href = result.data.cartCreate.cart.checkoutUrl;
    }
  })
  .catch(error => {
    console.error('Error:', error);
  });
});

//产品推荐购买相关
$(window).on('load', function() {
  getRecPur();
});

function getRecPur(){
  let formDate = {
      product_id:window.ShopifyAnalytics.meta.product.id,
      vari_id:$('#variantId').val(),
      currency_code:Shopify.currency.active?Shopify.currency.active:'USD'
  };
  $.ajax({
      url: 'https://backend.turboant.com/Index/Api/getRecommandPurchaseByProductId',
      type: 'POST',
      data: formDate,
      dataType: 'json',
      success(res) {
        if (res) {
          if(res.data.length==0){
              $('.com_pur_div').hide();
              return;
          }else{
              $('.com_pur_div').show();
          }
          let res_html = getComPurDiv(res.data,Shopify.currency.active);
          $('.com_pur_div').html(res_html);
          $('.pro_checkbox').change(function(){
              //console.log(this.value);
              //console.log(this.checked);
              let checked = this.checked;
              let vari_id = this.value;
              let img_obj = $("span[data-id=" + vari_id + "]");
              //console.log(img_obj.next(":visible"));
              //return;
              let prev_obj = img_obj.prev(":visible");
              let next_obj = img_obj.next(":visible");
              //console.log($("input[value='"+ vari_id +"']").next().next().next()[0].outerText.slice(1));
              let new_price = parseFloat($("input.pro_checkbox[value='"+ vari_id +"']").next().next()[0].innerText.replace(' CAD','').slice(1));
              let old_price = parseFloat($("input.pro_checkbox[value='"+ vari_id +"']").next().next().next()[0].outerText.replace(' CAD','').slice(1)?$("input.pro_checkbox[value='"+ vari_id +"']").next().next().next()[0].outerText.replace(' CAD','').slice(1):0);
              let new_price_total = $('.new_total_price_text')[0].innerText.replace(' CAD','');
              let old_price_total = $('.old_total_price>del')[0].innerText.replace(' CAD','');
              let currency = new_price_total.slice(0,1);
              new_price_total = parseFloat(new_price_total.slice(1));
              old_price_total = parseFloat(old_price_total.slice(1));
              console.log(new_price);
              console.log(old_price);
              if(checked){
                /*
                  img_obj.show();
                  img_obj.prev().show();
                */
                  $('.new_total_price_text').text(currency+(new_price_total+new_price).toFixed(2));
                  if(old_price){
                    $('.old_total_price>del').text(currency+(old_price_total+old_price).toFixed(2));
                  }else{
                    $('.old_total_price>del').text(currency+(old_price_total+new_price).toFixed(2));
                  }
                  
                  // if(old_price_total-old_price){
                  //   $('.old_total_price>del').show();
                  // }else{
                  //   $('.old_total_price>del').hide();
                  // }
                  
                  img_obj.css('opacity', 1);
                
              }else{
                /*
                  img_obj.hide();
                  if(prev_obj.length==0){
                      //第一个元素
                      next_obj.hide();
                  }else{
                      //其他元素
                      prev_obj.hide();
                  }
                */
                  $('.new_total_price_text').text(currency+(new_price_total-new_price).toFixed(2));
                  if(old_price){
                    $('.old_total_price>del').text(currency+(old_price_total-old_price).toFixed(2));
                  }else{
                    $('.old_total_price>del').text(currency+(old_price_total-new_price).toFixed(2));
                  }
                  
                  // if(old_price_total-old_price){
                  //   $('.old_total_price>del').show();
                  // }else{
                  //   $('.old_total_price>del').hide();
                  // }
                  
                  img_obj.css('opacity', 0.1);
            }
            if($('.new_total_price_text').text()==$('.old_total_price>del').text()){
              $('.old_total_price>del').hide();
            }else{
              $('.old_total_price>del').show();
            }
            if(Shopify.currency.active=='CAD'){
              $('.new_total_price_text').text($('.new_total_price_text').text()+' CAD');
              $('.old_total_price>del').text($('.old_total_price>del').text()+' CAD');
            }
          });
  
          $('.add_rec_to_cart_btn').click(function(){
              let formDate = {items:[]};
              $("input[name='mycheckbox']:checkbox:checked").each(function(){
                  formDate.items[formDate.items.length] = {id:$(this).val(),quantity:1};
              })
              $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                data: formDate,
                dataType: 'json',
                success(res) {
                  if (res) {
                    getCartData();
                  }
                },
                error(err) {
                  
                }
              });
          });
        }
      },
      error(err) {}
   });
}


function getComPurDiv(data,currency_code){
  let head_str = '<div class="rec_pur_title">Frequently Bought Together </div>';
  if (window.ShopifyAnalytics.meta.product.id == 6902815752273) {
    head_str = '<div class="rec_pur_title">Frequently Bought Together </div><div>Purchase of backup batteries is optional.</div>';
  }
  let img_div_str = '<div class="img_div">';
  let new_total_price = 0;
  let old_total_price = 0;
  let pro_list_div_str = '<div class="pro_list_div">';
  let has_compare_price = 0;
  $.each(data,function (index,domEle){
     
      let tmp_href = domEle.href?domEle.href:'/';
      let tmp_str = '<span data-id="'+domEle.vari_id+'"><a href='+tmp_href+'><img src="'+domEle.image_url+'" class="pro_img" id="img_'+domEle.vari_id+'"></a></span>';
      let compare_at_price = 0;
      if(domEle.compare_at_price){
          compare_at_price = domEle.compare_at_price;
      }
      let tmp_str_2 = '';
      let price_str = '$'+domEle.price;
      let compare_at_price_str = '$'+compare_at_price;
      if(currency_code=='CAD'){
        price_str = '$'+domEle.price+' CAD';
        compare_at_price_str = '$'+compare_at_price+' CAD';
      }
      if(index==0){
          img_div_str += tmp_str;
          
          if(compare_at_price){
            tmp_str_2 = '<span class="pro_list_name"> This item: '+domEle.title+'</span> <span class="pro_list_new_price">'+price_str+'</span> <span class="pro_list_old_price"><del>'+compare_at_price_str+'</del></span>';
          }else{
            tmp_str_2 = '<span class="pro_list_name"> This item: '+domEle.title+'</span> <span class="pro_list_new_price">'+price_str+'</span> <span class="pro_list_old_price"><del></del></span>';
          }
          pro_list_div_str = pro_list_div_str + '<div> <input class="pro_checkbox"  name="mycheckbox" type="checkbox" value="'+domEle.vari_id+'" checked="checked"  />' + tmp_str_2 + '</div>';
      }else{
          if(compare_at_price){
            tmp_str_2 = '<span class="pro_list_name"> '+domEle.title+'</span> <span class="pro_list_new_price">'+price_str+'</span> <span class="pro_list_old_price"><del>'+compare_at_price_str+'</del></span>';
          }else{
            tmp_str_2 = '<span class="pro_list_name"> '+domEle.title+'</span> <span class="pro_list_new_price">'+price_str+'</span> <span class="pro_list_old_price"><del></del></span>';
          }
          
          img_div_str = img_div_str + '<span class="img_plus">+</span>' + tmp_str;
          pro_list_div_str = pro_list_div_str + '<div> <input class="pro_checkbox"  name="mycheckbox" type="checkbox" value="'+domEle.vari_id+'" checked="checked" />' + tmp_str_2 + '</div>';
      }
      new_total_price += parseFloat(domEle.price);
      if(domEle.compare_at_price){
          old_total_price += parseFloat(domEle.compare_at_price);
          has_compare_price = 1;
      }else if(has_compare_price){
          old_total_price += parseFloat(domEle.price);
      }
  
  });
  img_div_str += '</div>';
  let tmp_str_3 = old_total_price?'<del>$'+old_total_price.toFixed(2)+'</del>':'<del></del>';
  if(currency_code=='CAD'){
      tmp_str_3 = old_total_price?'<del>$'+old_total_price.toFixed(2)+' CAD</del>':'<del></del>';
  }
  let new_total_price_str = '$'+new_total_price.toFixed(2);
  if(currency_code=='CAD'){
    new_total_price_str = '$'+new_total_price.toFixed(2)+' CAD';
  }
  let price_div_str = '<div class="price_div"><span class="new_total_price">Total Price: <span class="new_total_price_text">'+new_total_price_str+'</span> </span><span class="old_total_price">' +tmp_str_3+ '</span></div>';
  let add_to_cart_div_str = '<div class="com_pur_note">*Coupon(s) will apply at checkout.</div> <div class="add_to_cart_div"><button class="add_rec_to_cart_btn"><div class="add_to_cart_text">ADD SELECTED TO CART</div></button></div>';
  pro_list_div_str += '</div>';
  return head_str + img_div_str + price_div_str + add_to_cart_div_str + pro_list_div_str ;
}  

$(document).ready(function() {
  // 获取变体选择表单和价格元素
  var $variantSelect = $('#variantId');
  var hiddenInput = $('#variantId')[0];
  var $priceElement = $("#finalPrice");
  var $underlinedPrice = $("#underlinedPrice");

  // 创建一个用于处理变化的回调函数
  var onHiddenInputChange = function(mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
        var newValue = $(hiddenInput).val();
        console.log('Hidden input value changed to:', newValue);
        // 获取所选变体的ID
        var variantId = $(hiddenInput).val();

        // 根据ID获取价格
        var priceId = '#variant-price-' + variantId;
        var price = $(priceId).html();
        var comparePriceId = '#variant-compare-price-' + variantId;
        var comparePrice = $(comparePriceId).html();

        console.log(price);
        // 更新价格
        $priceElement.html(price);
        $underlinedPrice.html(comparePrice);
      }
    }
  };

  // 创建一个新的 MutationObserver 实例，并指定回调函数
  var observer = new MutationObserver(onHiddenInputChange);

  // 启动观察器，监听属性变化
  observer.observe(hiddenInput, { attributes: true });

});


// 订阅提交
$("#pre-sell-subscribe").click(function () {
  // 此处为请求
  $.ajax({
    url: 'https://backend.turboant.com/index/api/dealshopifycustomerTurboantPre',
    type: 'post',
    data: {
      account:'turboant.myshopify.com',
      email: $('#pre-sell-email').val(),
      tag: $('#pre-sell-subscribe').data('tag'),
    },
    dataType: 'json',
    success: (res) => {
        const { status, msg } = res;
        if(status === 1){
          $('#pre-sell-subscribe-success').show();
        }else{
          $('#pre-sell-subscribe').append(`<div class='tb-toast'>${msg}</div>`);
          setTimeout(function () {
            $('.tb-toast').remove();
          }, 1000)
        }
    }
  });
});

var R09S5Swiper = new Swiper(".R09S5Swiper", {
  slidesPerView: isMobile() ? 1.3 : 3.3,
  spaceBetween: isMobile() ? 12 : 24,
  scrollbar: {
    el: ".R09S5Swiper .swiper-scrollbar",
  },
  navigation: {
    nextEl: ".R09S5SwiperContainer .swiper-button-next",
    prevEl: ".R09S5SwiperContainer .swiper-button-prev",
  },
});
